module.exports = __webpack_public_path__ + "static/fonts/Robotolight.63d6f57.ttf";